import { Directive, HostListener, Output, EventEmitter, ElementRef } from '@angular/core';
import { FiFileUpload2Service } from '@fi-shared/fi-insert-media/fi-file-upload2.service';

@Directive({
    selector: '[fiDropHandler]',
    standalone: false,
})
export class FiDropHandlerDirective {
    @Output() fiDropHandler = new EventEmitter<File[]>();

    constructor(
        private fileUpload2Service: FiFileUpload2Service,
        private elRef: ElementRef<HTMLElement>,
    ) {}

    @HostListener('drop', ['$event'])
    onDrop($event: DragEvent) {
        $event.preventDefault();
        this.fileUpload2Service.extractFilesFromDrop($event.dataTransfer, $event.dataTransfer.files).then((result) => {
            this.fiDropHandler.next(result);
        });
    }

    @HostListener('dragenter', ['$event'])
    onDragEnter($event: DragEvent) {
        $event.dataTransfer.dropEffect = 'copy';
        $event.preventDefault();
    }

    @HostListener('dragover', ['$event'])
    onDragOver($event: DragEvent) {
        $event.dataTransfer.dropEffect = 'copy';
        $event.preventDefault();
    }

    @HostListener('dragleave', ['$event'])
    onDragLeave($event: DragEvent) {
        $event.preventDefault();
    }
}
